import React from "react";
import { Trans, useTranslation } from "react-i18next";
const ITUNES_URL = "https://apps.apple.com/app/alertmedia/id899199006";
const ITUNES_IMG = "https://s3-us-west-1.amazonaws.com/e-templates/default/ic_app_store_badge.png";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.alertmedia.android.alertmediapro.app";
const GOOGLE_PLAY_IMG = "https://s3-us-west-1.amazonaws.com/e-templates/default/ic_google_play_badge.png";

const Success = (props) => {
  const { t } = useTranslation();
  return (
    <div id="form-holder">
      <div className="intro">
        <div>
          <div className="form-holder">
            <div>
              {props.isActive ? (
                <p>{t("success.updated_profile")}</p>
              ) : (
                <p>
                  <Trans i18nKey="success.subscribed_text" values={{ customerName: props.customerName }} />
                </p>
              )}
              <p>
                <Trans
                  i18nKey="success.next_text"
                  components={{
                    loginLink: <a href={props.ncUrl} />,
                    iosLink: <a href={ITUNES_URL} target="_blank" />,
                    androidLink: <a href={GOOGLE_PLAY_URL} target="_blank" />,
                  }}
                />
              </p>
            </div>
            <div className="app-badges">
              <div className="label">{t("success.download_app_cta")}</div>
              <div className="badges">
                <a href={ITUNES_URL} target="itunes_store" title="Get Alert Media Pro for iOS">
                  <img alt="Get Alert Media Pro for iOS" src={ITUNES_IMG} />
                </a>
                <a href={GOOGLE_PLAY_URL} target="_blank" title="Get Alert Media Pro for Android">
                  <img alt="Get Alert Media Pro for Android" src={GOOGLE_PLAY_IMG} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
